class AnnouncementCountdown extends HTMLElement {
  #timer;
  #endsAt;

  connectedCallback() {
    const hours = this.#readNumber('hours', 3);
    const minutes = this.#randomBetween(this.#readNumber('minutesMin', 20), this.#readNumber('minutesMax', 59));
    const seconds = this.#randomBetween(this.#readNumber('secondsMin', 0), this.#readNumber('secondsMax', 59));

    this.#endsAt = Date.now() + (hours * 3600 + minutes * 60 + seconds) * 1000;
    this.#render();
    this.#timer = window.setInterval(() => this.#render(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.#timer);
  }

  #render() {
    const remaining = Math.max(0, this.#endsAt - Date.now());
    const totalSeconds = Math.floor(remaining / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    this.querySelector('[data-countdown-hours]')?.replaceChildren(String(hours).padStart(2, '0'));
    this.querySelector('[data-countdown-minutes]')?.replaceChildren(String(minutes).padStart(2, '0'));
    this.querySelector('[data-countdown-seconds]')?.replaceChildren(String(seconds).padStart(2, '0'));

    const timer = this.querySelector('[data-countdown-timer]');
    const expired = this.querySelector('[data-countdown-expired]');
    const isExpired = remaining === 0;

    timer?.toggleAttribute('hidden', isExpired);
    expired?.toggleAttribute('hidden', !isExpired);

    if (isExpired) window.clearInterval(this.#timer);
  }

  #readNumber(key, fallback) {
    const value = Number.parseInt(this.dataset[key] ?? '', 10);
    return Number.isNaN(value) ? fallback : Math.max(0, value);
  }

  #randomBetween(minimum, maximum) {
    const min = Math.min(minimum, maximum);
    const max = Math.max(minimum, maximum);
    const range = max - min + 1;

    if (window.crypto?.getRandomValues) {
      const randomValue = new Uint32Array(1);
      window.crypto.getRandomValues(randomValue);
      return min + (randomValue[0] % range);
    }

    return min + Math.floor(Math.random() * range);
  }
}

if (!customElements.get('announcement-countdown')) {
  customElements.define('announcement-countdown', AnnouncementCountdown);
}
